var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._l((_vm.rules),function(rule,index){return [_c('RuleTypeShow',{key:index,attrs:{"rule":rule}})]}),_vm._v(" "),_c('RuleAdd',{attrs:{"rule-reference":_vm.ruleReference,"rule-type":_vm.ruleType.composite}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }